import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Menu, UserCheck } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { persianDisplayText } from '@/lib/persianUi';
import IrancharsouqAdminSidebar from './IrancharsouqAdminSidebar';

export default function IrancharsouqAdminLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const firstName = persianDisplayText(user?.first_name, '');

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="admin-layout">
            <IrancharsouqAdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onLogout={handleLogout} />
            <div className="admin-main">
                {/* هدر تکراری حذف شد و فقط دکمه منوی موبایل باقی ماند */}
                <header className="admin-header mobile-only-header">
                    <div className="admin-header-left">
                        <button onClick={() => setSidebarOpen(true)} className="admin-menu-btn" aria-label="باز کردن منو"><Menu size={22} /></button>
                    </div>
                </header>
                <main className="admin-content"><Outlet /></main>
            </div>
        </div>
    );
}